import Render from 'components/render';
import { MARGIN_TYPES } from 'constants/constants';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import { formatFiat } from 'helpers/currency';
import { convertFromUSDtoINR } from 'helpers/utils';
import subscribe from 'HOC/subscribe';
import i18n from 'i18n/config';
import {
  inrConversionRateSelector,
  userMarginModeSelector,
} from 'selectors/otherSelectors';
import {
  blockedMarginCrossModeSelectorUsd,
  blockedMarginSelectorUsd,
  portfolioMarginSelector,
} from 'selectors/walletSelector';
import { useAppSelector } from 'storeHooks';
import Box from 'UIKit/Box';

import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const headerBlockedMargin = i18n.t('headerFooter:header.wallet.blockedAsMargin');
const blockedMarginPopOverIndianExchange = i18n.t(
  'headerFooter:header.wallet.blockedAsMarginPopOverIndianExchange'
);

const getBlockedMarginUSDRawValue = ({
  marginMode,
  blockedMarginIsolatedRawValue,
  blockedMargin,
  positionsUpl,
  blockedMarginCrossModeRawValue,
}) => {
  let blockedMarginUSDRawValue;

  switch (marginMode) {
    case MARGIN_TYPES.ISOLATED:
      blockedMarginUSDRawValue = blockedMarginIsolatedRawValue;
      break;
    case MARGIN_TYPES.PORTFOLIO:
      blockedMarginUSDRawValue = Number(blockedMargin ?? 0) + Number(positionsUpl ?? 0);
      break;
    case MARGIN_TYPES.CROSS:
      blockedMarginUSDRawValue = blockedMarginCrossModeRawValue;
      break;
    default:
      blockedMarginUSDRawValue = 0;
  }
  return blockedMarginUSDRawValue;
};

const BlockedMargin = subscribe(({ showAmount }: { showAmount: boolean }) => {
  const inrConversionRate = useAppSelector(inrConversionRateSelector);
  const blockedMarginIsolatedRawValue = useAppSelector(blockedMarginSelectorUsd);
  const blockedMarginCrossModeRawValue = useAppSelector(
    blockedMarginCrossModeSelectorUsd
  );
  const marginMode = useAppSelector(userMarginModeSelector);
  const portfolioMarginData = useAppSelector(portfolioMarginSelector);

  const { positions_upl: positionsUpl = 0, blocked_margin: blockedMargin } =
    portfolioMarginData?.aggregate || {};

  const blockedMarginUSDRawValue = getBlockedMarginUSDRawValue({
    marginMode,
    blockedMarginIsolatedRawValue,
    blockedMargin,
    positionsUpl,
    blockedMarginCrossModeRawValue,
  });

  const blockedMarginInInr = formatFiat(
    CURRENCY_TYPE.INR,
    Number(convertFromUSDtoINR(blockedMarginUSDRawValue ?? 0, inrConversionRate)),
    LOCALES.INDIA
  );

  const blockedMarginInUsd = formatFiat(CURRENCY_TYPE.USD, blockedMarginUSDRawValue);

  return (
    <Box className={styles['label-value-container']} data-testid="blocked-margin">
      <Box className={styles.label}>
        <TooltipWrapper
          title={headerBlockedMargin}
          body={blockedMarginPopOverIndianExchange}
        />
      </Box>
      <Box className={styles.value}>
        <Box className={styles.inr}>
          <Render when={showAmount} else="******">
            {blockedMarginInInr}
          </Render>
        </Box>
        <Box className={styles.usd}>
          <Render when={showAmount} else="******">
            {blockedMarginInUsd}
          </Render>
        </Box>
      </Box>
    </Box>
  );
});

export default BlockedMargin;
